import React from 'react';
import styles from './Issues.module.scss';
import Button from '../../Button'
import Img from 'gatsby-image'
import Link from 'gatsby-link'

const Issues = (props) => (
  <div className={styles.Issues}>
    <div className={styles.Issues__Wrapper}>
      <div className={styles.Issues__Text}>
        <h2 className={`h2 ${styles.Issues__Headline}`}>{props.title}</h2>
        <p className={styles.Issues__Copy}>{props.text}</p>
      </div>
      <div className={styles.Locations}>
      {props.countries.map((country, i) =>
        <Link to={country.link} className={styles.Location} key={i} title={ `View ${country.title} destination` }>
          <Img style={{ position:'absolute',top:0, left:0, right:0, bottom:0 }}
             sizes={ country.backgroundImage.sizes } />
          <h3>{country.title}</h3>
          <div className={styles.Location__Copy}>{country.description}</div>
          <div className={styles.Location__Arrow}><img src="/images/icon-circle-arrow.svg" alt="arrow link" /></div>
        </Link>
      )}
      </div>
      <div className={ `${styles.Issues__Text} text-center`}>
        <p>Not sure which destination is right for you? <Button text="Take the Quiz" href={ props.link } /></p>
      </div>
    </div>
  </div>
)

export default Issues;



// WEBPACK FOOTER //
// ./src/components/_Redesign/Issues/index.js